import API from "../services/apiservices";
import Vue from "vue";

export default {
  namespaced: true,
  namespace: 'profilerStore',

  state: {
    storename: "profilerStore",
    profiler: {
        id: null
      , idUsuario: null
      , isLogged: false
      , UserName: ""
      , Franquia: true
      , Representante: true
      , Cliente: true
      , Colaborador: true
      , Transportadora: true
      , Gestor: true
      , Consumidor: true
      , TermoPrivacidade: null
      , AssinouTermoPrivacidade: true
      , franqueado: false
      , email: ""
      , displayName: ""
      , facePic: ""
      , Roles: []
    },
    emptyprofiler: {
        id: null
      , idUsuario: null
      , isLogged: false
      , UserName: ""
      , Franquia: false
      , Representante: false
      , Cliente: false
      , Colaborador: false
      , Transportadora: false
      , Gestor: false
      , Consumidor: false
      , TermoPrivacidade: null
      , AssinouTermoPrivacidade: false
      , franqueado: false
      , email: ""
      , displayName: ""
      , facePic: ""
      , Roles: []
      , Grupos: []
    }
  },

  getters: {
    gtxStore: () => ({ name: "profilerStore", route: "Servicos/Login/Profile", setter: "setProfiler" }),
    gtxProfiler: (state) => (state.profiler && state.profiler.idUsuario) ? state.profiler : state.emptyprofiler,
    gtxProfilerisLogged: () => (Vue.$cookies.get("token") && Vue.$cookies.get("token") !== "") ? true : false,
    gtxProfilerEmpty: (state) => state.emptyprofiler,
    gtxProfilerDefaults: (state) => state.profiler.Defaults,
    gtxProfiler_UserName: (state) => state.profiler.UserName,
    gtxProfiler_DisplayName: (state) => state.profiler.displayName || state.profiler.UserName,
    gtxProfiler_error: (state) => state.profiler.error,
    gtxProfiler_Grupos: (state) => state.profiler.Grupos || [],

    gtxProfiler_DEV: (state) => state.profiler.Roles.find(r => r.Role == "SERVICOSDEV") ? true : false,
    gtxProfiler_Auth: (state) => state.profiler.Roles.find(r => r.Role == "SERVICOSROLE") ? true : false,
    gtxProfiler_ExigeContrato: (state) => state.profiler.Roles.find(r => r.Role == "BARTZENROLE") ? false : true,
    gtxProfiler_Bartzen: (state) => state.profiler.Roles.find(r => r.Role == "BARTZENROLE") ? true : false,
    gtxProfiler_Franquia: (state) => state.profiler.Roles.find(r => r.Role == "FRANQUIASROLE") ? true : false,
    gtxProfiler_Transportadora: (state) => state.profiler.Roles.find(r => r.Role == "TRANSPORTADORASROLE") ? true : false,
    gtxProfiler_GeraRoyalty: (state) => state.profiler.franqueado || false,
    gtxProfiler_VisualizarValores: () => true, //(state) => state.profiler.Roles.find(r => ((r.Role == "GERPROMOB") || (r.grupo == "FINANCEIRO"))) ? true : false,
    gtxProfiler_rolescsv: (state) => state.profiler.Roles.map(r => r.Role).join(";"),
    gtxProfilerRoles: (state) => state.profiler.Roles || [],
    
    gtxProfiler_CPD: (state, getters) => getters.gtxProfiler_Grupos.find(r => r.grupo == "CPD") ? true : false,
    gtxProfiler_Gerente: (state) => state.profiler.Roles.find(r => ((r.Role == "GERPROMOB"))) ? true : false,
    gtxProfiler_Financeiro: (state, getters) => getters.gtxProfiler_Grupos.find(r => r.grupo == "FINANCEIRO") ? true : false,
    gtxProfiler_Comercial: (state, getters) => getters.gtxProfiler_Grupos.find(r => r.grupo == "COMERCIAL") ? true : false,
    //gtxProfiler_Comercial: (state) => true,
  },

  mutations: {
    setProfiler: (state, profiler) => state.profiler = profiler,
    setProfilerdata: (state, data) => (state.profiler.data = data),
  },

  actions: {
    actProfilerGet( {commit} ) {
      return new Promise((res, rej) => {
        try {
            API.get('Servicos/Login/Profile', {}, false).then((apidata) => {
              const data = API.prepareData(apidata.data);
              // console.log('actProfilerGet:', data.data[0]);
              commit('setProfiler', data.data[0]);
              res(data);
            });
        } catch (err) {
          rej(err);
        }
      });
    },
    actProfilerClear({ commit, getters }) {
      commit('setProfiler', getters.gtxProfilerEmpty);
    }
  },
};
